import { createSelector } from "reselect";
export const selectTranslationsState = createSelector((state) => state.translations, translations => translations);
export const selectTranslations = createSelector(selectTranslationsState, translations => translations.list);
